import { ReportButton, Loader } from '@geneo2-web/shared-ui';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Question } from '@protos/content_management/content.db_pb';
import PrintableQuestionPaper from '../../Assessment/QuestionPaperGenerator/ReviewQuestionPaper/PrintableQuestionPaper';
import {
  MultiSubjectSection,
  QuestionSectionMeta,
  SectionQuestionMetaData,
} from '@protos/learning_management/lms.db_pb';
import { useWhiteLabeledUrl } from 'apps/teacher/src/utils/customHooks';
import { getSubjectNameFromEnum } from '../../Home/home.utils';

interface IDownloadPaper {
  assessmentId: number;
  questionList: Question[];
  quesImagesEnabled: { [key: string]: boolean };
  title?: string;
  grade?: string;
  section?: string;
  subject?: string;
  multiSubjectSections?: MultiSubjectSection[];
}

export default function DownloadPaperButton(props: IDownloadPaper) {
  const {
    questionList,
    quesImagesEnabled,
    title,
    grade,
    section,
    subject,
    multiSubjectSections,
  } = props;

  const [printAnswer, setPrintAnswer] = useState(false);
  const [loading, setLoading] = useState(false);

  const printablePaperRef = useRef<any>(null);
  const school_logo_url = useWhiteLabeledUrl();

  // Disable page scroll when loading is true
  useEffect(() => {
    if (loading) {
      // Save the current overflow style
      const originalOverflow = document.body.style.overflow;
      // Disable scrolling
      document.body.style.overflow = 'hidden';

      // Cleanup: restore scrolling when component unmounts or loading becomes false
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [loading]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            width: '100vw',
            height: '100vh',
          }}
        >
          <Loader />
        </div>
      )}
      <Box
        sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}
      >
        <ReportButton
          buttonText="Download Paper"
          buttonList={[
            {
              name: 'Question Paper',
              onClick: async () => {
                setPrintAnswer(false);
                setTimeout(async () => {
                  await printablePaperRef?.current?.handlePrint(false);
                }, 1000);
              },
            },
            {
              name: 'Answer Paper',
              onClick: async () => {
                setPrintAnswer(true);
                setTimeout(async () => {
                  await printablePaperRef?.current?.handlePrint(true);
                }, 1000);
              },
            },
          ]}
        />
      </Box>
      <PrintableQuestionPaper
        questionSectionMetaInfo={
          multiSubjectSections && multiSubjectSections.length > 0
            ? multiSubjectSections.map(
                (section) =>
                  new QuestionSectionMeta({
                    questionSectionName: section.subject
                      ? getSubjectNameFromEnum(section.subject)
                      : '',
                    sectionQuestionsInfo: section.multiSubjectSubSections
                      .map((subSection) =>
                        subSection.subSectionMetaData.map(
                          (meta) =>
                            new SectionQuestionMetaData({
                              questionId: meta.questionId,
                              sequence: meta.sequence,
                              showMedia: meta.showMedia,
                            })
                        )
                      )
                      .flat() as SectionQuestionMetaData[],
                  })
              )
            : [
                new QuestionSectionMeta({
                  sectionQuestionsInfo: questionList.map(
                    (ques, index) =>
                      new SectionQuestionMetaData({
                        questionId: ques.questionId,
                        sequence: index,
                        showMedia: ques?.questionId
                          ? !!quesImagesEnabled[ques.questionId]
                          : true,
                      })
                  ),
                }),
              ]
        }
        sectionMetaStatements={[]}
        questionsList={questionList}
        loading={loading}
        setLoading={setLoading}
        printAnswer={printAnswer}
        ref={printablePaperRef}
        instructions={[]}
        // loading={loading}
        // setLoading={setLoading}
        printableFontSize={14}
        // schoolName={user_info?.schoolDetails[0]?.schoolName}
        assessmentTitle={title || 'Assessment Paper'}
        grade={grade}
        section={section}
        subject={subject}
        SchoolLogo={school_logo_url}
      />
    </>
  );
}
